import { NavigationRoute } from '@nextforce/api'
import { makeStyles, Text } from '@rneui/themed'
import { t } from 'app/i18l'
import { CrewListGroup } from 'crew_list/types'
import React from 'react'
import { FlatList, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { PressableOpacity } from 'shared/components/pressable_opacity'
import UserCell from './user_cell'

interface Props {
  groups: CrewListGroup[] | undefined
  onPress: (route: NavigationRoute | undefined) => void
}

export default function CrewListView({ groups, onPress }: Props) {
  const styles = useStyles()

  if (!groups) {
    return <View></View>
  }

  const seeAllText = t('seeAll')
  return (
    <SafeAreaView edges={['left', 'right', 'bottom']} style={styles.root}>
      <View style={styles.container}>
        <FlatList
          keyExtractor={group => group.id}
          data={groups}
          renderItem={({ item }) =>
            item.count > 0 ? (
              <View>
                <View style={styles.rowTitleTextContainer}>
                  <Text
                    style={styles.subheadingText}
                  >{`${item.name} (${item.count})`}</Text>
                  <PressableOpacity
                    onPress={() => onPress(item.route)}
                    style={styles.navigationButton}
                  >
                    <Text style={styles.navigationButtonText}>
                      {seeAllText}
                    </Text>
                  </PressableOpacity>
                </View>

                <FlatList
                  horizontal={true}
                  style={styles.rowStyle}
                  data={item.users}
                  renderItem={iterator => {
                    return (
                      <UserCell user={iterator.item} onPressUser={onPress} />
                    )
                  }}
                />
              </View>
            ) : null
          }
        />
      </View>
    </SafeAreaView>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
  },
  container: {
    flex: 1,
    backgroundColor: theme.colors?.grey6,
  },
  rowTitleTextContainer: { flexDirection: 'row', margin: 10, paddingTop: 10 },
  navigationButton: { marginLeft: 'auto', marginRight: 5 },
  rowStyle: {
    backgroundColor: theme.colors?.white,
    paddingTop: 10,
    paddingBottom: 10,
  },
  subheadingText: { fontSize: 14, color: theme.colors?.black },
  navigationButtonText: { color: theme.colors?.grey2 },
}))
